import type { TUser } from '@/services/auth/auth.types.ts';
import { userInitials } from '@/components/Layouts/account.ts';

interface IAvatar {
  user?: TUser;
  size?: 'sm' | 'md';
}

/** Initials avatar; a rounded square so it reads as "account" rather than a generic chat bubble. */
export const Avatar = ({ user, size = 'sm' }: IAvatar) => (
  <span className={`app-avatar app-avatar--${size}`} aria-hidden>
    {userInitials(user) || '·'}
  </span>
);
